export const CommunicationTemplate = {
    TEXT: 'text',
    BANNER: 'banner'
}
export class CompanyCommunication {
    display: boolean;
    acceptingCondition: boolean;
    template: string;
    textTemplate?: CompanyCommunicationText;
    bannerTemplate?: CompanyCommunicationBanner;
}

export class CompanyCommunicationText {
    title: string;
    message: string;
}

export class CompanyCommunicationBanner {
    bannerId: number;
    bannerImage: any;
}


// WEBPACK FOOTER //
// ./src/app/model/user/communication-preference.model.ts